// src/features/api/apiSlice.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_DOMAIN } from '../../utils/constants';
import { CHANGE_OLD_PASSWORD, CHANGE_PASS, FORGOT_URL, LOGIN_URL, PROFILE_UPDATE, UPDATE_PASS, upload_file } from './authConstant';
import {store} from "../../app/store"


const protectedEndpoints = [
  PROFILE_UPDATE,
  CHANGE_OLD_PASSWORD,
];



export const loginSlice = createApi({
  reducerPath: 'loginApi', // Unique name for the slice
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_DOMAIN, // Replace with your API base URL
  }),
//   baseQuery: fetchBaseQuery({ baseUrl: BASE_DOMAIN }), // Replace with your API base URL
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: LOGIN_URL, // Replace with your login endpoint
        method: 'POST',
        body: credentials,
      }),
    }),
    signup: builder.mutation({
        query: (userDetails) => ({
          url: 'signup', // Replace with your sign-up endpoint
          method: 'POST',
          body: userDetails,
        }),
      }),
      forgotPassword: builder.mutation({
        query: (email) => ({
          url: FORGOT_URL, // Replace with your forgot password endpoint
          method: 'POST',
          body: { email },
        }),
      }),
      updatePassword: builder.mutation({
        query: (payload) => ({
          url: UPDATE_PASS, // Replace with your forgot password endpoint
          method: 'POST',
          body: payload,
        }),
      }),
      changePassword: builder.mutation({
        query: (payload) => ({
          url: CHANGE_PASS, // Replace with your forgot password endpoint
          method: 'POST',
          body: payload,
        }),
      }),
      profileUpdate: builder.mutation({
        query: ({ id, payload }) => ({
          url: `${PROFILE_UPDATE}/${id}`, // Replace with your forgot password endpoint
          method: 'PUT',
          body: payload,
        }),
        transformResponse: (response) => {
          // Handle plain text responses
          if (typeof response === 'string') {
            return { message: response };
          }
          return response;
        }
      }),

      upload: builder.mutation({
            query: (credentials) => ({
              url: upload_file, // Replace with your login endpoint
              method: 'POST',
              body: credentials,
            }),
          }),
      
      oldpaswordUpdate: builder.mutation({
        query: ({ id, payload }) => ({
          url: `${CHANGE_OLD_PASSWORD}/${id}`, // Replace with your forgot password endpoint
          method: 'PUT',
          body: payload,
        }),
        transformResponse: (response) => {
          // Handle plain text responses
          if (typeof response === 'string') {
            return { message: response };
          }
          return response;
        }
      }),
  }),
});

export const { useLoginMutation,useSignupMutation,useForgotPasswordMutation,useUpdatePasswordMutation,useChangePasswordMutation,useProfileUpdateMutation,useOldpaswordUpdateMutation,useUploadMutation } = loginSlice; // Export the auto-generated hook
